import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/beeline-logo.svg'
import _imports_1 from '@/assets/icons/beeline-logo-small.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  src: _imports_1,
  class: "logo-small",
  alt: "bee-logo-small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isNotBiometryPage)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          class: "logo",
          src: _imports_0,
          alt: "bee-logo-big"
        }, null, -1)),
        (_ctx.isNotNumberRegistrationAndInitialized)
          ? (_openBlock(), _createElementBlock("img", _hoisted_2))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}